import React, { FC, useMemo } from 'react';

import MultiSelect from '../../../multi-select';
import { Typography } from '../../../typography';

interface IInputProps {
	title: string;
	value: any;
	fields: any;
	callback(props: any): void;
}

const Fields: FC<IInputProps> = ({ title, value, fields, callback }) => {
	const setTitle = (type: string): string => {
		return type
			.replace(/([A-Z])/g, ' $1')
			.replace(/^./, (str: string) => str.toUpperCase().trim());
	};

	const options = useMemo(
		() =>
			fields.map((field: any) => {
				return {
					title: setTitle(field),
					value: field,
				};
			}),
		[fields]
	);

	return (
		<div style={{ width: '100%' }}>
			<div>
				<Typography type="bold" size="medium" text={title} />
			</div>
			<div>
				<MultiSelect
					options={options}
					callback={(option: any) => callback(option.value)}
					value={value}
				/>
			</div>
		</div>
	);
};

export default Fields;
